<template>
	<v-card class="nav-panel" rounded="xl">
		<div class="nav-panel__header">
			<v-icon color="primary">shopping_bag</v-icon>
			<span class="nav-panel__title">{{ t('Shopping Cart') }}</span>
			<v-btn icon variant="text" size="small" :title="t('Checkout')" :aria-label="t('Checkout')" @click="act(goToCheckout)">
				<v-icon>shopping_cart</v-icon>
			</v-btn>
			<v-btn icon variant="text" size="small" :disabled="!cart.count" :title="t('The shopping cart will be cleared!')" :aria-label="t('The shopping cart will be cleared!')" @click="act(clearCart)">
				<v-icon>delete_sweep</v-icon>
			</v-btn>
		</div>
		<v-divider />

		<div v-if="cart.count" class="nav-panel__list">
			<NavCartLine v-for="line in cart.regular" :key="line.key" :line="line" @action="onLineAction" />

			<template v-if="cart.rsw.length">
				<div class="nav-panel__section">{{ t('Shopping Cart RSW') }}</div>
				<NavCartLine v-for="line in cart.rsw" :key="line.key" :line="line" show-reference @action="onLineAction" />
			</template>

			<template v-if="cart.assort.length">
				<div class="nav-panel__section">{{ t('Shopping Cart Assort') }}</div>
				<template v-for="company in cart.assort" :key="company.companyId">
					<div class="nav-cart__company">{{ company.companyName }}</div>
					<template v-for="location in company.locations" :key="location.key">
						<div class="nav-cart__location">
							<button type="button" class="nav-cart__location-label" @click="act(() => openAssortLocation(location))">{{ location.label }}</button>
							<span v-if="location.franco" class="nav-cart__franco" :class="`nav-cart__franco--${location.franco.level}`">
								{{ location.franco.text }}
								<template v-if="location.franco.valueText">({{ location.franco.valueText }})</template>
							</span>
							<v-btn icon variant="text" size="x-small" @click="act(() => clearAssortLocation(location))">
								<v-icon>delete_sweep</v-icon>
							</v-btn>
						</div>
						<NavCartLine v-for="line in location.items" :key="line.key" :line="line" @action="onLineAction" />
					</template>
				</template>
			</template>
		</div>

		<div v-else class="nav-panel__empty">
			<v-icon size="40">remove_shopping_cart</v-icon>
			<p>{{ t('NoData') }}</p>
		</div>

		<template v-if="cart.count">
			<v-divider />
			<v-card-actions class="nav-panel__footer">
				<v-btn color="primary" variant="flat" block prepend-icon="shopping_cart_checkout" @click="act(goToCheckout)">{{ t('Checkout') }}</v-btn>
			</v-card-actions>
		</template>
	</v-card>
</template>

<script setup>
import { computed } from 'vue';
import NavCartLine from './NavCartLine.vue';
import { legacyNav } from '@/iframe/legacyNavState';
import { changeCartQuantity, clearAssortLocation, clearCart, goToCheckout, openAssortLocation, removeCartLine, showCartLineDetail } from '@/iframe/legacyNavActions';
import { openProductImage } from '@/composables/useChromeDialogs';
import { useTranslator } from '@/composables/useTranslator';

const emit = defineEmits(['close']);
const t = useTranslator();

const cart = computed(() => legacyNav.cart);

const act = (action) => {
	emit('close');
	action();
};

const onLineAction = ({ type, key }) => {
	if (type === 'increase') changeCartQuantity(key, 1);
	else if (type === 'decrease') changeCartQuantity(key, -1);
	else if (type === 'remove') removeCartLine(key);
	else if (type === 'detail') act(() => showCartLineDetail(key));
	else if (type === 'zoom') act(() => openProductImage(key));
};
</script>
